import { z } from 'zod';

import { contentTypesLiteral } from './content-types-literal.schema';

export const contentfulEntrySchema = z.object({
  sys: z.object({
    id: z.string(),
    locale: z.string(),
    contentType: z.object({
      sys: z.object({
        id: contentTypesLiteral,
      }),
    }),
  }),
});
